import {
    Component,
    OnInit,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { MenuProyectoService } from 'src/app/common/services/menu-proyecto.service';

@Component({
    selector: 'app-headercontent',
    templateUrl: './headercontent.component.html',
    styleUrls: ['./headercontent.component.css'],
})
export class HeaderContentComponent implements OnInit, OnChanges {
    @Input() descripcionGeneral: any = '';

    ngOnChanges(changes: SimpleChanges): void {}

    constructor(private _menuProyectoService: MenuProyectoService) {}

    async ngOnInit(): Promise<void> {}
}
